export enum FiDisplayType {
    List = 1,
    Grid = 2,
}
